export const CREATE_SHIPMENT_REQUEST = 'CREATE_SHIPMENT_REQUEST';
export const CREATE_SHIPMENT_SUCCESS = 'CREATE_SHIPMENT_SUCCESS';
export const CREATE_SHIPMENT_FAILURE = 'CREATE_SHIPMENT_FAILURE';
export const createShipmentDataSuccess = (payload) => ({
    type: CREATE_SHIPMENT_SUCCESS,
    payload,
});
export const createShipmentDataRequest = (payload) => ({
    type: CREATE_SHIPMENT_REQUEST,
    payload,
});
export const createShipmentDataFailure = (payload) => ({
    type: CREATE_SHIPMENT_FAILURE,
    payload,
});
